import React, { useEffect, useState } from "react"
import { Container, Row, Col } from "reactstrap"
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import sideImg from "../../assets/images/confirmImg.jpg"
import { fetchNodeData } from "../../utils/common-fetchData"
import moment from "moment"
import axios from "axios"
import configure from "configure"
import VerionHistory from "./Version/versionHistory"


const Footer = () => {
  const [modalOpen, setModalOpen] = useState(false)
  const [boxWidth, setBoxWidth] = useState(0)
  const [versions, setVersions] = useState([])
  const [currentVersion, setCurrentVersion] = useState("")

  // Fetch only the current version on initial load
//  useEffect(() => {
//   const fetchCurrentVersion = async () => {
//     try {
//       const res = await axios.get(`${configure.nodeApi}/currentVersion`)
//       if (res.data.success && res.data.data) {
//         setCurrentVersion(res.data.data.version || "")
//       }
//     } catch (err) {
//       console.error("Failed to fetch current version:", err)
//     }
//   }
//   fetchCurrentVersion()
// }, [])

  // Handle responsive width
  useEffect(() => {
    const updateWidth = () => {
      const viewportWidth = window.innerWidth
      setBoxWidth(viewportWidth * 0.95)
    }
    updateWidth()
    window.addEventListener("resize", updateWidth)
    return () => window.removeEventListener("resize", updateWidth)
  }, [])

  // Fetch full version history only when opening modal
  const handleOpenModal = async () => {
    // setModalOpen(true)
    try {
      const res = await fetchNodeData(() => {}, "versionControl/")
      if (res.success && res.data) {
        setVersions(res.data.versionData || [])
        setModalOpen(true)
      }
    } catch (err) {
      console.error("Failed to fetch version history:", err)
    }
  }

  return (
    <React.Fragment>
      <footer className="footer">
        <Container fluid={true}>
          <Row className="justify-space-between">
            <Col md={6}>{new Date().getFullYear()} © Ambrella Consultancy.</Col>
            <Col
              md={6}
              className="cursor-pointer fw-semibold text-end"
              onClick={handleOpenModal}
            >
              {/* {console.log(`currentVersion`, currentVersion)}
              Version {currentVersion || "Loading..."} */}
            </Col>
          </Row>
        </Container>
      </footer>

      <div className={`note-sticky-form ${modalOpen ? "d-block" : "d-none"}`}>
        <Draggable handle=".modal-header" cancel=".modal-body">
          <ResizableBox
            width={boxWidth}
            style={{
              position: "fixed",
              top: "6%",
              right: "3%",
              zIndex: "1055",
              backgroundColor: "#fff",
              maxHeight: "fit-content",
              transform: "translate(-50%, -50%)",
            }}
          >
            <div className="modal-header pe-4">
              <h5 className="modal-title mt-0">Version History</h5>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                className="btn-modal-close"
              >
                <span aria-hidden="true" className="btn-modal-span">
                  &times;
                </span>
              </button>
            </div>
            <VerionHistory versions={versions} />
          </ResizableBox>
        </Draggable>
      </div>
    </React.Fragment>
  )
}

export default Footer
